import React from "react";
import { AppSettingsIcon } from "../../Icon/AppSettingsIcon";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const SettingsButton = (props: IAppButtonProps) => (
    <AppButton variant="outlined" startIcon={<AppSettingsIcon />} {...props}>
        {props.children}
    </AppButton>
);
